/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UiRelease } from '../products.models';
import { ConfigService } from '@windriver/authentication';

@Component({
  selector: 'wsn-license-agreement',
  templateUrl: './license-agreement.component.html',
  styleUrls: ['./license-agreement.component.scss']
})
export class LicenseAgreementComponent implements OnInit {
  public apiBackendBaseUrl: string;

  constructor(
    public dialogRef: MatDialogRef<LicenseAgreementComponent>,
    private configService: ConfigService,
    @Inject(MAT_DIALOG_DATA) public data: UiRelease
  ) {}

  ngOnInit(): void {
    this.configService.configState.subscribe((config: any) => {
      if (config) {
        this.apiBackendBaseUrl = config.apiUrl;
      }
    });
  }

  openLicense(): void {
    const encodedPath = encodeURIComponent(this.data.license_agreement.url);
    const fullUrl = `${this.apiBackendBaseUrl}/v1/tools/minio-render?path=${encodedPath}`;
    window.open(fullUrl, '_blank');
  }
}
